module.exports = __webpack_public_path__ + "img/2FamiliesPlaying.d9f06cbe.svg";